import { useEffect, useState } from 'react'
import { applyDateMask, toBrDate, toISODate } from './DateInput'

// Campo de data SEMPRE em dd/mm/aaaa (31/10/2026). Substitui o <input type="date">, cujo
// calendario segue o idioma do navegador (em ingles aparecia "mm/dd/yyyy").
// Mesma "cara" do input nativo para a troca ser direta: recebe value em ISO (aaaa-mm-dd) e
// chama onChange({ target: { value, name } }) com ISO - ou '' enquanto a data esta incompleta.
// min/max sao aceitos e ignorados (as telas validam o periodo).

interface DataBRProps {
  value?: string | null
  onChange?: (e: { target: { value: string; name?: string } }) => void
  onBlur?: () => void
  name?: string
  className?: string
  required?: boolean
  disabled?: boolean
  placeholder?: string
  min?: string
  max?: string
  'aria-label'?: string
}

export function DataBR({ value, onChange, onBlur, name, className, required, disabled, placeholder = 'dd/mm/aaaa', 'aria-label': ariaLabel }: DataBRProps) {
  const iso = (value ?? '').slice(0, 10)
  const [texto, setTexto] = useState(toBrDate(iso))

  // valor trocado por fora (ex.: botao "Ultimos 12 meses", abrir outro registro)
  useEffect(() => {
    if (iso !== toISODate(texto)) setTexto(toBrDate(iso))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iso])

  return (
    <input
      type="text"
      inputMode="numeric"
      maxLength={10}
      name={name}
      aria-label={ariaLabel}
      placeholder={placeholder}
      className={className}
      required={required}
      disabled={disabled}
      autoComplete="off"
      value={texto}
      onChange={e => {
        const t = applyDateMask(e.target.value)
        setTexto(t)
        const novo = toISODate(t)
        if (novo !== iso) onChange?.({ target: { value: novo, name } })
      }}
      onBlur={onBlur}
    />
  )
}
